import {toast} from 'react-toastify';
import axios from 'axios';
import * as THREE from "three";

import React, { useEffect, useState, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import SideStyle from '../style/sideStyle';
import { AddIcon } from '../formAk/formUtil';
import { loadSTLFile, loadPLYFile } from '../fileIO/fileLoader';

import Param from '../store/param';
import Control from '../store/control';


const FormSetup = () => {
  const style = SideStyle();
  const param = Param.Get('setup');
  const setParam = Param.Get('setParam');
  const setControl = Control.Get('setControl');


  useEffect(() => {
    setParam(s => {s.activestep = 0})
    // 全てのパラメータをghni最初に全部送って初期化
    var obj = {}
    obj['f00'] = {}

    Object.keys(param).forEach(function (key) {
      obj['f00'][key] = param[key]
    });
  }, []);

  const handleValueGeometry = (e) => {
    // setParam(s => {s.setup[e.target.name] = Number(e.target.value)});

    const url = process.env.REACT_APP_RHINO_COMPUTE + '/afo';
    const data = {
      'description': 'aaaaaaaaa',
      'trimline_knee2ankle': e.target.value
    };
    const header = {
      headers: {
        'Content-Type': 'application/json',
        //'Content-Type': "text/plain",
        //'Access-Control-Allow-Origin': '*',
      }
    };
    axios.post(
      url, 
      data, 
      header,
      //{crossDomain: true},
      //{mode: 'cors'}
      )
    .then(res => {
      let tempVertices = res.data.obj.vertices;
      // rotate 90 degs around x axis due to different coordinate system
      tempVertices = tempVertices.map(vertex => [vertex[0], vertex[2], vertex[1]]);
      const tempFaces = res.data.obj.faces;

      // convert array to float32array for three.js buffergeometry
      const vertices = new Float32Array(tempVertices.flat());
      // convert array to uint16array for three.js buffergeometry
      const faces = new Uint16Array(tempFaces.flat());

      const afoGeometry = new THREE.BufferGeometry();
      afoGeometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
      afoGeometry.setIndex(new THREE.BufferAttribute(faces, 1));
      afoGeometry.computeVertexNormals();

      setControl(s => { s.afoGeometry = afoGeometry });
    })
    .catch(err => {
      console.log('error:', err);
    });
  };

  return (
    <div className={style.outside}>
      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <TextField
          id='filled-number'
          name='trimline_knee2ankle'
          label='Trimline Knee to Ankle'
          type='number'
          defaultValue={0.5}
          fullWidth
          onBlur={handleValueGeometry}
          InputProps={{
            endAdornment:
              <AddIcon 
                unit='' 
                helptext={''}
                title=''
                imgSrc=''
              />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:0.5, 
            max:1,
            step:0.05
          }}
        />
      </Grid>
    </div>
  );
}
export default FormSetup;
